// extracted by mini-css-extract-plugin
module.exports = {"slider":"galeryMobileCarousel_slider__iP1ZD","slide":"galeryMobileCarousel_slide__QQztt"};